import { Injectable } from '@angular/core';
import { MenuItemModel } from '../../models/menu-item';
import { Router } from '@angular/router';
import { Observable, Subject } from 'rxjs';
import { menuItemDataAdmin, menuItemDataUser } from 'src/app/config/menu';



@Injectable({
    providedIn: 'root'
})
export class DashboardService {

    public clientChanges$: Subject<any> = new Subject();
    public changeClientActive: boolean = true;
    public headerTitle: string;
    public lastMenuItemSelected: MenuItemModel;
    public lastSubmenuItemSelected: any;
    /*  public menuItemDataOld: MenuItemModel[] = [
         {id: 'clientes', icon: 'fa fa-quora', text: 'Inicio',description:'Inicio', isSelected: false },
         {
             id: 'anexo_1',
             icon: 'fa band-aid',
             text: 'Procedimientos 1',
             description:'Procedimientos',
             isSelected: false,
             expandable: [
                 
                 {
                     id: 'control_documentos', fatherId: 'anexo_1', text: 'CONTROL DE DOCUMENTOS', isSelected: false 
                 }
              
             ]
         },
         {
             id: 'anexo_2',
             icon: 'fa band-aid',
             text: 'Procedimientos 2',
             description:'Procedimientos',
             isSelected: false,
             expandable: [
                 
                 {id: 'limpieza_desinfeccion', fatherId: 'anexo_2', text: 'LIMPIEZA Y DESINFECCIÓN -CAMIONES-', isSelected: false},
                 {id: 'limpieza', fatherId: 'anexo_2', text: 'CONTROL DE LIMPIEZA Y DESINFECCIÓN', isSelected: false},
                 {id: 'plan_limpieza_desinfeccion', fatherId: 'anexo_2', text: 'PLAN DE LIMPIEZA Y DESINFECCIÓN', isSelected: false},
               
             ]
         },
         {
             id: 'anexo_4',
             icon: 'fa band-aid',
             text: 'Procedimientos 4',
             description:'Procedimientos',
             isSelected: false,
             expandable: [
                 {id: 'zumos', fatherId: 'anexo_4', text: 'REGISTRO DE CONTROL DE ZUMOS ÍNDICE Y MADUREZ', isSelected: false},
                 {id: 'producto', fatherId: 'anexo_4', text: 'CONTROL DE ENTRADAS DE MATERIA PRIMA', isSelected: false},
                 {id: 'limpieza', fatherId: 'anexo_4', text: 'CONTROL DE LIMPIEZA Y DESINFECCIÓN', isSelected: false},
                 {id: 'plan_limpieza_desinfeccion', fatherId: 'anexo_4', text: 'PLAN DE LIMPIEZA Y DESINFECCIÓN', isSelected: false},
                 {id: 'test-de-vida-comercial', fatherId: 'anexo_4', text: 'TEST DE VIDA COMERCIAL', isSelected: false},
                 {id: 'control-de-conformidad', fatherId: 'anexo_4', text: 'CONTROL DE CONFORMIDAD', isSelected: false},
                 {id: 'etiquetas', fatherId: 'anexo_4', text: 'CONTROL DE ETIQUETAS', isSelected: false},
                 {id: 'pesos', fatherId: 'anexo_4', text: 'REGISTRO DE CONTROL DE PESOS PITUFO', isSelected: false},
                 {id: 'pesos', fatherId: 'anexo_4', text: 'REGISTRO DE CONTROL DE PESOS PITUFO', isSelected: false},
                 {id: 'girsac', fatherId: 'anexo_4', text: 'REGISTRO DE CONTROL DE PESOS MALLA (GIRSAC)', isSelected: false},
               
             ]
         },
         
 
         {id: 'tiritas', icon: 'fa band-aid', text: 'Tiritas',description:'CONTROL DE TIRITAS' ,isSelected: false, ruta: 'tiritas'},
         {id: 'control', icon: 'fa band-aid', text: 'Cristales',description:'CONTROL DE CRISTALES, PLÁSTICOS, LUCES Y METALES',isSelected: false, ruta: 'control'},
         {id: 'limpieza', icon: 'fa band-aid', text: 'Limpieza',description:'CONTROL DE LIMPIEZA Y DESINFECCIÓN' ,isSelected: false, ruta: 'limpieza'},
         {id: 'producto', icon: 'fa band-aid', text: 'Producto',description:'CONTROL DE ENTRADAS DE MATERIA PRIMA' ,isSelected: false, ruta: 'producto'},
         {id: 'utensilios', icon: 'fa band-aid', text: 'Utensilios',description:'CONTROL UTENSILIOS Y GRAPAS', isSelected: false, ruta: 'utensilios'},
         {id: 'parametro', icon: 'fa band-aid', text: 'Parámetros', description:'CONTROL DE PARÁMETROS EN CÁMARAS FRIGORÍFICAS',isSelected: false, ruta: 'parametro'},
         {id: 'pesos', icon: 'fa band-aid', text: 'Peso pitufo', description:'REGISTRO DE CONTROL DE PESOS PITUFO',isSelected: false, ruta: 'pesos'},
         {id: 'girsac', icon: 'fa band-aid', text: 'Peso girsac', description:'REGISTRO DE CONTROL DE PESOS GIRSAC',isSelected: false, ruta: 'girsac'},
         {id: 'zumos', icon: 'fa band-aid', text: 'Zumos', description:'REGISTRO DE CONTROL DE ZUMOS',isSelected: false, ruta: 'zumos'},
         {id: 'etiquetas', icon: 'fa band-aid', text: 'Etiquetas', description:'CONTROL DE ETIQUETAS',isSelected: false, ruta: 'etiquetas'},
         {id: 'test-de-vida-comercial', icon: 'fa band-aid', text: 'Test de vida', description:'TEST DE VIDA COMERCIAL',isSelected: false, ruta: 'test-de-vida-comercial'},
         {id: 'control-de-conformidad', icon: 'fa band-aid', text: 'Conformidad', description:'CONTROL DE CONFORMIDAD',isSelected: false, ruta: 'control-de-conformidad'},
         {id: 'transporte', icon: 'fa band-aid', text: 'Transporte', description:'DATOS DEL TRANSPORTE',isSelected: false, ruta: 'transporte'},
         {id: 'transporte-rutas', icon: 'fa band-aid', text: 'Transporte rutas', description:'TRANSPORTE RUTAS',isSelected: false, ruta: 'transporte-rutas'},
         {id: 'mantenimiento-camiones', icon: 'fa band-aid', text: 'Camiones', description:'MANTENIMIENTO CAMIONES',isSelected: false, ruta: 'mantenimiento-camiones'},
         {id: 'agua-cloro', icon: 'fa band-aid', text: 'Agua cloro', description:'AGUA CLORO',isSelected: false, ruta: 'agua-cloro'},
         {id: 'agua', icon: 'fa band-aid', text: 'Agua', description:'AGUA',isSelected: false, ruta: 'agua'},
         {id: 'limpieza_desinfeccion', icon: 'fa band-aid', text: 'Limpieza y desinfección', description:'LIMPIEZA Y DESINFECCIÓN',isSelected: false, ruta: 'limpieza_desinfeccion'},
         {id: 'encerado', icon: 'fa band-aid', text: 'Encerado', description:'ENCERADO',isSelected: false, ruta: 'encerado'},
         {id: 'lavadora', icon: 'fa band-aid', text: 'Lavadora', description:'LAVADORA',isSelected: false, ruta: 'lavadora'},
         {id: 'etileno', icon: 'fa band-aid', text: 'Etileno', description:'ETILENO',isSelected: false, ruta: 'etileno'},
         {id: 'nebulizador', icon: 'fa band-aid', text: 'Nebulizador', description:'NEBULIZADOR',isSelected: false, ruta: 'nebulizador'},
         {id: 'cuaderno_campo', icon: 'fa band-aid', text: 'Cuaderno de campo', description:'CUADERNO DE CAMPO',isSelected: false, ruta: 'cuaderno_campo'},
         {id: 'confecciones_diarias', icon: 'fa band-aid', text: 'Confección diarias', description:'CONFECCIONES DIARIAS',isSelected: false, ruta: 'confecciones_diarias'},
         {id: 'plagas', icon: 'fa band-aid', text: 'Plagas', description:'Control de plagas',isSelected: false, ruta: 'plagas'},
         {id: 'camaras_etileno', icon: 'fa band-aid', text: 'Cámaras de etileno', description:'Cámaras de etileno',isSelected: false, ruta: 'camaras_etileno'},
         {id: 'residuos_peligrosos', icon: 'fa band-aid', text: 'Residuos peligrosos', description:'Residuos peligrosos',isSelected: false, ruta: 'residuos_peligrosos'},
         {id: 'control_linea', icon: 'fa band-aid', text: 'Control línea', description:'Control línea',isSelected: false, ruta: 'control_linea'},
         {id: 'diario_cogida', icon: 'fa band-aid', text: 'Control diario cogida', description:'Control diario cogida',isSelected: false, ruta: 'diario_cogida'},
         {id: 'peso_materia', icon: 'fa band-aid', text: 'Peso entrada materia prima', description:'CONTROL PESO ENTRADA MATERIA PRIMA',isSelected: false, ruta: 'peso_materia'},
         {id: 'perdida_peso_diaria', icon: 'fa band-aid', text: 'Pérdida de peso diaria', description:'PÉRDIDA DIARIA DE PESO EN LA CONFECCIÓN',isSelected: false, ruta: 'perdida_peso_diaria'},
         {id: 'perdida_peso_no_pesada', icon: 'fa band-aid', text: 'Materia prima no pesada', description: 'REGISTRO DE ENTRADA MATERIA PRIMA NO PESADA',isSelected: false, ruta: 'perdida_peso_no_pesada'},
         {id: 'contra_incendios', icon: 'fa band-aid', text: 'Contra incendios', description: 'VERIFICACIÓN INSTALACIONES DE PROTECCION CONTRA INCENDIOS (ANUAL- TRIMESTRAL)',isSelected: false, ruta: 'contra_incendios'},
         {id: 'plan_limpieza_desinfeccion', icon: 'fa band-aid', text: 'Plan de limpieza y desinfección', description: 'PLAN DE LIMPIEZA Y DESINFECCIÓN',isSelected: false, ruta: 'plan_limpieza_desinfeccion'},
         {id: 'reuniones', icon: 'fa band-aid', text: 'Reuniones', description: 'REUNIONES ',isSelected: false, ruta: 'reuniones'},
         {id: 'formacion', icon: 'fa band-aid', text: 'Formación', description: 'FORMACIÓN ',isSelected: false, ruta: 'formacion'},
         {id: 'tratamiento_no_conformidad', icon: 'fa band-aid', text: 'Tratamiento de las no conformidades', description: 'TRATAMIENTO DE LAS NO CONFORMIDADES ',isSelected: false, ruta: 'tratamiento_no_conformidad'},
         {id: 'control_documentos', icon: 'fa band-aid', text: 'Control de documentos', description: 'CONTROL DE DOCUMENTOS',isSelected: false, ruta: 'control_documentos'},
         {id: 'organigrama_funcional', icon: 'fa band-aid', text: 'Organigrama funcional', description: 'Organigrama funcional',isSelected: false, ruta: 'organigrama_funcional'},
        
          
     ]; */

    public menuItemDataOld: MenuItemModel[] = localStorage.getItem('role') === ' ROLE_ADMIN' ? menuItemDataAdmin : menuItemDataUser;
    // public menuItemDataOld:MenuItemModel[] = localStorage.getItem('role') === ' ROLE_ADMIN' ? menuItemDataAdmin: menuItemDataUser ;
    public menuItemData: MenuItemModel[] = [];


    constructor(private router: Router) {

    }

    private unSelectLastMenuItem() {
        if (this.lastMenuItemSelected) {
            this.lastMenuItemSelected.isSelected = false;
        }
    }

    private unSelectLastSubmenuItem() {
        if (this.lastSubmenuItemSelected) {
            this.lastSubmenuItemSelected.isSelected = false;
        }
    }

    private selectMenuItem(menuItem: MenuItemModel) {
        //console.log('menuItem', menuItem);

        this.lastMenuItemSelected = menuItem;
        // this.setHeaderTitle(menuItem.description);
        menuItem.isSelected = true;
    }

    private selectSubmenuItem(submenuId: string) {
        let father;

        if (father = this.findFather(submenuId)) {
            if (father.expandable && father.expandable.length > 0) {
                father.expandable.filter(submenu => submenu.id === submenuId)
                    .forEach(submenu => {
                        submenu.isSelected = true;
                        this.lastSubmenuItemSelected = submenu;
                    });
            }
        }
    }

    private isMenuExpandable(menuItem: MenuItemModel): boolean {
        return menuItem.expandable && menuItem.expandable.length > 0;
    }

    private getMenuItem(menuItemId: string): MenuItemModel[] {
        if (this.menuItemData) {
            return this.menuItemData.filter(i => i.id === menuItemId) || [];
        } else {
            return [];
        }
    }

    private getSubmenuItem(submenuItemId) {
        const father = this.findFather(submenuItemId);

        if (father && father.expandable && father.expandable.length > 0) {
            return father.expandable
                .filter(submenu => {
                    submenu.father = father;
                    return submenu.id === submenuItemId;
                })[0];
        } else {
            return null;
        }

    }

    private findFather(id: string) {
        let founded = false;
        let father = null;

        this.menuItemData.forEach(menu => {
            if (!founded && menu.expandable) {
                menu.expandable.forEach(submenu => {
                    if (submenu.id === id) {
                        founded = true;
                        father = menu;
                    }
                });
            }
        });

        return father;
    }


    public setMenuItem(menuItemId: string) {
        const menuItem: MenuItemModel = this.getMenuItem(menuItemId)[0];
        //console.log("Menuitem",menuItem ,"MenuitemSelected", menuItem.isSelected);
        if (menuItem) {
            this.unSelectLastMenuItem();
            this.unSelectLastSubmenuItem();

            this.selectMenuItem(menuItem);

            if (this.isMenuExpandable(menuItem)) {
                // const submenu = menuItem.expandable[0];
                // this.selectSubmenuItem(submenu.id);
                // this.setHeaderTitle(submenu.text);

                // this.router.navigate(['dashboard', submenu.id]);
            } else {
                this.setHeaderTitle(menuItem.description);

                this.router.navigate(['dashboard', menuItemId]);
            }
        }
        /* if (menuItem && !menuItem.isSelected) {
            this.unSelectLastMenuItem();
            this.unSelectLastSubmenuItem();

            this.selectMenuItem(menuItem);

            if (this.isMenuExpandable(menuItem)) {
                const submenu = menuItem.expandable[0];
                this.selectSubmenuItem(submenu.id);
                this.setHeaderTitle(submenu.text);
               
                this.router.navigate(['dashboard', submenu.id]);
            } else {
                this.setHeaderTitle(menuItem.description);
              
                this.router.navigate(['dashboard', menuItemId]);
            }
        } */
    }

    public setSubmenuItem(submenuItemId: string) {
        const submenuItem = this.getSubmenuItem(submenuItemId);

        if (submenuItem) {
            if (!submenuItem.father.isSelected) {
                this.unSelectLastSubmenuItem();
                this.unSelectLastMenuItem();
                this.selectMenuItem(submenuItem.father);
            }

            this.unSelectLastSubmenuItem();
            this.selectSubmenuItem(submenuItem.id);

            this.setHeaderTitle(submenuItem.text);
            this.router.navigate(['dashboard', submenuItemId]);
        }
    }

    public setHeaderTitle(headerTitle: string) {
        this.headerTitle = headerTitle;
    }

    public onMenuItemClick(menuItemId: string) {
        this.setMenuItem(menuItemId);
    }

    public onSubmenuItemClick(submenuItemId: string) {
        this.setSubmenuItem(submenuItemId);
    }

    public onChangeClient(): Observable<any> {
        return this.clientChanges$.asObservable();
    }

    public emitClientChange() {
        this.clientChanges$.next();
    }

    /**
     *
     *  Construimos nuestro menu, con la informacion,
     *  recogida de la base de datos y que esta guardadad
     *  en localstorage @revisarMenu
     * 
     */
    public revisarMenu() {

        this.menuItemData = [];

        

        if (localStorage.getItem('role') != null && localStorage.getItem('role') == "ROLE_ADMIN") {
            let datos = JSON.parse(localStorage.getItem('vpe_user_tag_1'));

            try {


                let nombre: string = datos.name;
                if (nombre.localeCompare('Locatec') == 0) {
                    this.menuItemDataOld = menuItemDataAdmin;
                } else {
                    this.menuItemDataOld = menuItemDataAdmin;
                }

            } catch (error) {

            }
            this.menuItemData = this.menuItemDataOld;
        } else {
            this.menuItemDataOld = menuItemDataUser;
            if (localStorage.getItem('documentos') != null) {
                let arrayDocumentos = localStorage.getItem('documentos').split(";");
                let idx;

                for (let index = 0; index < (arrayDocumentos.length); index++) {
                    const element = arrayDocumentos[index].replace("\"", "");
            

                    for (let index2 = 0; index2 < this.menuItemDataOld.length; index2++) {
                        const elemento = this.menuItemDataOld[index2].id;
                        //console.log('elemento', elemento , 'element', element);
                        if (elemento.localeCompare(element) == 0) {

                            this.menuItemData.push(this.menuItemDataOld[index2]);
                        }

                    }
                    /*   idx = this.menuItemDataOld.find(it => it.id === element);
                      console.log("idx",idx);
                      if (idx) this.menuItemData.push(idx); */

                }

            }
        }
        /*  if(localStorage.getItem('documentos')!=null){
             let arrayDocumentos=localStorage.getItem('documentos').split(";");
             let idx;
             for (let index = 0; index < (arrayDocumentos.length); index++) {
                 const element = arrayDocumentos[index].replace("\"","");
                 console.log("element",element);
                 //console.log("element ",element);
                 for (let index2 = 0; index2 < this.menuItemDataOld.length; index2++) {
                     const elemento = this.menuItemDataOld[index2].id;
                     //console.log(elemento);
                     if(elemento==element){
                         this.menuItemData.push(this.menuItemDataOld[index2]);
                     }
                     
                 }
               /*   idx = this.menuItemDataOld.find(it => it.id === element);
                 console.log("idx",idx);
                 if (idx) this.menuItemData.push(idx); 
 
             }
 
         } */
    }
    public deleteMenu() {
        this.menuItemData = [];
    }
}
